import { Spacing } from '@hg/stylizator/utils'
import * as React from 'react'
const SwarmbytesTopMenu = React.lazy(() => import('app/components/SwarmbytesTopMenu'))
const SwarmbytesFooter = React.lazy(() => import('app/components/SwarmbytesFooter'))

interface Props {
  withPadding?: boolean
}

const SwarmbytesLayout: React.FC<React.PropsWithChildren<Props>> = ({ children, withPadding }) => (
  <>
    <SwarmbytesTopMenu />
    {withPadding && <Spacing top={8} />}
    {children}
    <SwarmbytesFooter />
  </>
)

export default SwarmbytesLayout
